import axios from 'axios'
import config from './config'

const api = axios.create({
  baseURL: config.host, // 请求的公共地址部分
  // baseURL: 'http://192.168.1.140:9208/manage/api', // 请求的公共地址部分
  // baseURL: 'http://tyjx.hfrjkf.cn/manage/api', // 请求的公共地址部分
  timeout: 1000000 // 请求超时时间 当请求时间超过10秒还未取得结果时 提示用户请求超时
})

// interceptors axios的拦截器对象
api.interceptors.request.use(config => {
  const lang = localStorage.getItem('locale') || 'zh-CN'
  if (config.method === 'get') {
    config.params = { lang, ...config.params }
  } else {
    config.data = config.data || {}
    if (typeof config.data === 'object' && !(config.data instanceof FormData)) {
      config.data = { ...config.data, lang }
    }
  }
 return config // 将配置完成的config对象返回出去 如果不返回 请求则不会进行
}, err => {
 // 请求发生错误时的处理 抛出错误
Promise.reject(err)
})


api.interceptors.response.use(res => {
  // 我们一般在这里处理，请求成功后的错误状态码 例如状态码是500，404，403
  // res 是所有相应的信息
  // console.log(res.data)
 return Promise.resolve(res.data)
}, err => {
  // 服务器响应发生错误时的处理
  Promise.reject(err)
})

export default api






// WEBPACK FOOTER //
// ./src/utils/request.js